import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=2b233e5b"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports